import { render, staticRenderFns } from "./ClientCrashTable.vue?vue&type=template&id=24d3f160"
import script from "./ClientCrashTable.vue?vue&type=script&lang=ts"
export * from "./ClientCrashTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports